import React from 'react';

interface Properties {
  height?: number;
  width?: number;
  color?: string;
}

/** Exact "symbol 1" (justify) asset from the Variance modal's Indent Figma frame. */
const LeftIndent = ({ height = 14, width = 14, color = 'black' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.583333 3.5H13.4167C13.5714 3.5 13.7197 3.43854 13.8291 3.32915C13.9385 3.21975 14 3.07138 14 2.91667C14 2.76196 13.9385 2.61358 13.8291 2.50419C13.7197 2.39479 13.5714 2.33333 13.4167 2.33333H0.583333C0.428623 2.33333 0.28025 2.39479 0.170854 2.50419C0.061458 2.61358 0 2.76196 0 2.91667C0 3.07138 0.061458 3.21975 0.170854 3.32915C0.28025 3.43854 0.428623 3.5 0.583333 3.5Z'
        fill={color}
      />
      <path
        d='M13.4167 5.25H5.25C5.09529 5.25 4.94692 5.31146 4.83752 5.42085C4.72812 5.53025 4.66667 5.67862 4.66667 5.83333C4.66667 5.98804 4.72812 6.13642 4.83752 6.24581C4.94692 6.35521 5.09529 6.41667 5.25 6.41667H13.4167C13.5714 6.41667 13.7197 6.35521 13.8291 6.24581C13.9385 6.13642 14 5.98804 14 5.83333C14 5.67862 13.9385 5.53025 13.8291 5.42085C13.7197 5.31146 13.5714 5.25 13.4167 5.25Z'
        fill={color}
      />
      <path
        d='M13.4167 11.0833H5.25C5.09529 11.0833 4.94692 11.1448 4.83752 11.2542C4.72812 11.3636 4.66667 11.512 4.66667 11.6667C4.66667 11.8214 4.72812 11.9697 4.83752 12.0791C4.94692 12.1885 5.09529 12.25 5.25 12.25H13.4167C13.5714 12.25 13.7197 12.1885 13.8291 12.0791C13.9385 11.9697 14 11.8214 14 11.6667C14 11.512 13.9385 11.3636 13.8291 11.2542C13.7197 11.1448 13.5714 11.0833 13.4167 11.0833Z'
        fill={color}
      />
      <path
        d='M13.4167 8.16667H0.583333C0.428623 8.16667 0.28025 8.22813 0.170854 8.33752C0.061458 8.44692 0 8.59529 0 8.75C0 8.90471 0.061458 9.05308 0.170854 9.16248C0.28025 9.27188 0.428623 9.33333 0.583333 9.33333H13.4167C13.5714 9.33333 13.7197 9.27188 13.8291 9.16248C13.9385 9.05308 14 8.90471 14 8.75C14 8.59529 13.9385 8.44692 13.8291 8.33752C13.7197 8.22813 13.5714 8.16667 13.4167 8.16667Z'
        fill={color}
      />
    </svg>
  );
};

export default LeftIndent;
